// CodeQuest 前端 API 客户端。开发环境通过 Vite 代理 /api → 本地 wrangler。
// 若后端不可用，调用方应回退到本地示例数据，保证页面可用。

const TOKEN_KEY = 'cq_token';

export const getToken = () => localStorage.getItem(TOKEN_KEY);
export const setToken = t => {
    if (t) localStorage.setItem(TOKEN_KEY, t);
    else localStorage.removeItem(TOKEN_KEY);
    window.dispatchEvent(new Event('cq-auth-change'));
};

async function request (path, {method = 'GET', body, auth = false, admin = false} = {}) {
    const headers = {};
    if (body !== undefined) headers['Content-Type'] = 'application/json';
    if (auth) {
        const t = getToken();
        if (t) headers.Authorization = `Bearer ${t}`;
    }
    if (admin) headers['X-Admin-Token'] = localStorage.getItem('cq_admin_token') || 'dev-admin-token';
    const res = await fetch(`/api${path}`, {
        method,
        headers,
        body: body !== undefined ? JSON.stringify(body) : undefined
    });
    const data = await res.json().catch(() => ({}));
    if (!res.ok) throw new Error(data.error || `请求失败（${res.status}）`);
    return data;
}

export const api = {
    health: () => request('/health'),
    home: () => request('/home'),
    register: payload => request('/auth/register', {method: 'POST', body: payload}),
    login: payload => request('/auth/login', {method: 'POST', body: payload}),
    me: () => request('/me', {auth: true}),
    myProjects: () => request('/me/projects', {auth: true}),
    listBadges: () => request('/badges', {auth: Boolean(getToken())}),
    listQuests: () => request('/quests', {auth: Boolean(getToken())}),
    listProjects: category => request(`/projects${category ? `?category=${category}` : ''}`),
    getProject: id => request(`/projects/${id}`),
    galleryMeta: () => request('/gallery-meta'),
    createProject: payload => request('/projects', {method: 'POST', body: payload, auth: true}),
    updateProject: (id, payload) => request(`/projects/${id}`, {method: 'PUT', body: payload, auth: true}),
    getLessonProject: lessonId => request(`/lessons/${lessonId}/project`, {auth: true}),
    uploadProjectFile: (id, blob) => {
        const headers = {};
        const t = getToken();
        if (t) headers.Authorization = `Bearer ${t}`;
        return fetch(`/api/projects/${id}/file`, {method: 'PUT', headers, body: blob}).then(async res => {
            const data = await res.json().catch(() => ({}));
            if (!res.ok) throw new Error(data.error || `请求失败（${res.status}）`);
            return data;
        });
    },
    listLessons: () => request('/lessons'),
    getLesson: id => request(`/lessons/${id}`),
    evaluateLesson: (lessonId, payload) => request(`/lessons/${lessonId}/evaluate`, {method: 'POST', body: payload}),
    verifyAdmin: () => request('/admin/session', {admin: true}),
    saveLesson: (id, payload) => request(`/admin/lessons/${id}`, {method: 'PUT', body: payload, admin: true}),
    publishLesson: (id, payload) => request(`/admin/lessons/${id}/full`, {method: 'PUT', body: payload, admin: true}),
    addLessonStep: (id, payload) => request(`/admin/lessons/${id}/steps`, {method: 'POST', body: payload, admin: true}),
    updateLessonStep: (stepId, payload) => request(`/admin/steps/${stepId}`, {method: 'PUT', body: payload, admin: true}),
    deleteLessonStep: stepId => request(`/admin/steps/${stepId}`, {method: 'DELETE', admin: true}),
    getProgress: () => request('/progress', {auth: true}),
    saveProgress: payload => request('/progress', {method: 'POST', body: payload, auth: true})
};
